import { formatCurrency } from "@/common/utils/formatters";
import { BankingDepositsData } from "@/features/privateCompanies/types/bankingDeposits/bankingDeposits.type";

interface TotalValueTableCellProps {
  bankingDeposit: BankingDepositsData;
}

const TotalValueTableCell = ({ bankingDeposit }: TotalValueTableCellProps) => {
  if (!bankingDeposit.total_value) {
    return null;
  }

  return (
    <div>
      <p>
        {formatCurrency(Number(bankingDeposit.total_value || 0))} Total
      </p>

      {Number(bankingDeposit.fee_total || 0) > 0 && (
        <p className="text-xs text-yellow-400">
          {formatCurrency(Number(bankingDeposit.fee_total || 0))} em Tarifas
        </p>
      )}
    </div>
  );
}

export default TotalValueTableCell;
